export const FIRST_TWO_WEEKS_THRESHOLD = 14;

const INELIGIBLE = Object.freeze({ isEligible: false, loading: false } as const);
const LOADING = Object.freeze({ isEligible: false, loading: true } as const);

export type WelcomeFromRovoChatEligibility = {
	isEligible: boolean;
	loading: boolean;
};

export const getWelcomeFromRovoChatEligibility = ({
	currentUserPersonalSpaceKey,
	isCurrentSpacePersonal,
	isNewUser,
	isNewUserLoading,
	spaceKey,
	shouldSkipEligibilityCheck,
}: {
	currentUserPersonalSpaceKey?: string | null;
	isCurrentSpacePersonal?: boolean;
	isNewUser: boolean | null | undefined;
	isNewUserLoading?: boolean;
	spaceKey?: string;
	shouldSkipEligibilityCheck: boolean;
}): WelcomeFromRovoChatEligibility => {
	if (shouldSkipEligibilityCheck) {
		return INELIGIBLE;
	}

	if (isCurrentSpacePersonal) {
		if (currentUserPersonalSpaceKey === undefined) {
			return LOADING;
		}

		if (
			currentUserPersonalSpaceKey === null ||
			!spaceKey ||
			spaceKey === currentUserPersonalSpaceKey
		) {
			return INELIGIBLE;
		}
	}

	// Treat undefined loading as unresolved until useIsNewUser returns a definitive state.
	if (isNewUserLoading !== false) {
		return isNewUser === false ? INELIGIBLE : LOADING;
	}

	if (isNewUser !== true) {
		return INELIGIBLE;
	}

	return { isEligible: true, loading: false };
};
